// General
import React, { Component } from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
//Redux Form
import { Field, reduxForm } from "redux-form";
// Style
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import { Button, ControlLabel, FormGroup } from "react-bootstrap";
// Translation
import { injectIntl, FormattedMessage } from "react-intl";

import s from "./ListPlaceStep1.css";
import bt from "../../components/commonStyle.css";

// Internal Components
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";
import FooterButton from "./FooterButton";
import SidePanel from "./SidePanel";

// Locale
import messages from "../../locale/messages";

import { imageCdnUrl, url } from "../../config";
import validate from "./validate";
import update from "./update";

import DefaultIcon from "/public/SiteIcons/defaultIcon.svg";
import InputFieldComponent from "../Common/FormField/InputFieldComponent";

class Page9 extends Component {
  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    formErrors: PropTypes.object,
  };

  constructor(props) {
    super(props);
    if (typeof window !== "undefined") {
      this.ReactQuill = require("react-quill");
    }
    this.state = {
      spaces: [],
      isDisabled: false,
    };
  }

  componentDidMount() {
    const { formErrors, listingFields } = this.props;
    if (formErrors != undefined) {
      if (formErrors.hasOwnProperty("syncErrors")) {
        this.setState({ isDisabled: true });
      } else {
        this.setState({ isDisabled: false });
      }
    }
    if (listingFields != undefined) {
      this.setState({
        spaces: listingFields.spaces,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { formErrors, listingFields } = nextProps;
    if (formErrors != undefined) {
      if (formErrors.hasOwnProperty("syncErrors")) {
        this.setState({ isDisabled: true });
      } else {
        this.setState({ isDisabled: false });
      }
    }
    if (listingFields != undefined) {
      this.setState({
        spaces: listingFields.spaces,
      });
    }
  }

  checkboxGroup = ({ label, name, options, input }) => (
    <ul className={cx(s.listContainer, s.safetyAmenitiesFlex)}>
      {options.map((option, index) => {
        if (option.isEnable === "1") {
          return (
            <li className={cx("amenitiesCheckBox", s.flex)} key={index}>
              <div className={s.checkBoxOutline}>
                <div
                  className={cx(
                    s.amenitiesCheckBoxWrapper,
                    "darkModeAmenitiesCheckBoxWrapper",
                    { [s.checked]: input.value.indexOf(option.id) !== -1 },
                    {
                      ["darkModeAmenitiesChecked"]:
                        input.value.indexOf(option.id) !== -1,
                    },
                    "svgImg"
                  )}
                  onClick={() => {
                    const newValue = [...input.value];
                    if (newValue.indexOf(option.id) !== -1) {
                      newValue.splice(newValue.indexOf(option.id), 1);
                    } else {
                      newValue.push(option.id);
                    }
                    input.onChange(newValue);
                  }}
                >
                  {option.image ? (
                    <img
                      src={imageCdnUrl + "amenities/" + option.image}
                      className={cx(
                        s.imgSection,
                        "imgSectionRtl",
                        "darkModeFilterNone"
                      )}
                    />
                  ) : (
                    <img
                      src={DefaultIcon}
                      className={cx(s.imgSection, "imgSectionRtl")}
                    />
                  )}
                  <div className={s.checkoutText}>{option.itemName}</div>
                </div>
              </div>
            </li>
          );
        }
      })}
    </ul>
  );

  renderQuill = ({
    input,
    label,
    type,
    meta: { touched, error },
    className,
  }) => {
    const { formatMessage } = this.props.intl;
    const ReactQuill = this.ReactQuill;
    let modules = {
      toolbar: [
        [{ header: "1" }, { header: "2" }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link"],
      ],
      clipboard: {
        matchVisual: false,
      },
    };

    let formats = [
      "header",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
    ];
    return (
      <div>
        <ReactQuill
          {...input}
          onChange={(newValue, delta, source) => {
            if (source === "user") {
              input.onChange(newValue);
            }
          }}
          onBlur={(range, source, quill) => {
            if (quill.getHTML() == "<p><br></p>") {
              input.onBlur("");
            } else {
              input.onBlur(quill.getHTML());
            }
          }}
          modules={modules}
          formats={formats}
          theme="snow"
          placeholder={formatMessage(messages.checkInLabel)}
        />
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  render() {
    const { handleSubmit, previousPage, formPage, step, nextPage } = this.props;
    const { formatMessage } = this.props.intl;
    const { spaces, isDisabled } = this.state;
    const ReactQuill = this.ReactQuill;

    return (
      <div className={s.grid}>
        <SidePanel
          title={formatMessage(messages.stepOneCommonHeading)}
          landingContent={formatMessage(messages.checkInHeading)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel, "textWhite")}>
                <FormattedMessage {...messages.checkInInformation} />
              </ControlLabel>
              {typeof window !== "undefined" && this.ReactQuill ? (
                <Field name="checkinInfo" component={this.renderQuill} />
              ) : (
                <div>Rich text editor not available</div> // Fallback for SSR
              )}
            </FormGroup>
          </div>
          <FooterButton
            isDisabled={isDisabled}
            nextPage={nextPage}
            previousPage={previousPage}
            previousPagePath={"amenities"}
            nextPagePath={"faqs"}
            formPage={formPage}
            step={step}
          />
        </form>
      </div>
    );
  }
}

Page9 = reduxForm({
  form: "ListPlaceStep1", // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update,
})(Page9);

const mapState = (state) => ({
  userData: state.account.data,
  formErrors: state.form.ListPlaceStep1,
  listingFields: state.listingFields.data,
});

const mapDispatch = {};

export default injectIntl(
  withStyles(s, bt)(connect(mapState, mapDispatch)(Page9))
);
